export const SET_WEBSOCKET_ERROR = 'WEBSOCKET_ERROR_SET'

class ReWebSocket {
  constructor(uri, onOpen) {
    this.onCallback = undefined
    this.stateGetter = undefined
    this.uri = uri
    this.connect(onOpen)

    this.connect = this.connect.bind(this)
    this.onMessage = this.onMessage.bind(this)
    this.receive = this.receive.bind(this)
    this.emit = this.emit.bind(this)
  }

  connect(onOpen) {
    this.ws = new WebSocket(this.uri)
    // use fat array function to get correct this (or it will be ws)
    this.ws.onmessage = e => this.onMessage(e)
    this.ws.onopen = () => this.onOpenConnection(onOpen)
    this.ws.onclose = () => this.onCloseConnection(onOpen)
  }

  onCloseConnection(onOpen) {
    this.connect(onOpen)
  }

  onOpenConnection(onOpen) {
    // clear the websocketError when websocket connects if it is set
    if (this.onCallback && this.stateGetter) {
      const { websocketError } = this.stateGetter().global
      if (websocketError === 'error') {
        this.onCallback({ type: SET_WEBSOCKET_ERROR, payload: '' })
      }
    }
    onOpen()
  }

  onMessage(event) {
    if (this.onCallback) {
      this.onCallback(JSON.parse(event.data))
    }
  }

  receive(callback, getState) {
    this.onCallback = callback
    this.stateGetter = getState
  }

  emit(action) {
    // only send message if readyState is 'OPEN' (1: 'OPEN')
    if (this.ws.readyState === 1) {
      this.ws.send(JSON.stringify(action))
    } else if (this.onCallback && this.stateGetter) {
      // when calling emit and websocket is not in 'CONNECTED' state
      // set websocketError to 'error' if not already set
      const { websocketError } = this.stateGetter().global
      if (websocketError !== 'error') {
        this.onCallback({ type: SET_WEBSOCKET_ERROR, payload: 'error' })
      }
    }
  }
}

export const setupWebSocket = ({ uri }) => new Promise((resolve) => {
  const webSocket = new ReWebSocket(uri, () => resolve(webSocket))
})
